// tslint:disable:no-any
import React, { Component } from 'react';
import { DisplayDepth } from '../components/Display';

export interface IDivesMapDetailModalProps {
    hideConfirmSubmit?: () => void;
    display: any;
    dive: any;
    shared: boolean;
    viewDetail: any;
    viewSharedDetail: any;
}

interface IDivesMapDetailModalState {
    shared: boolean;
    display: any;
    dive: any;
}

export default class DivesMapDetailModal extends Component<
    IDivesMapDetailModalProps,
    IDivesMapDetailModalState
> {
    constructor(props: IDivesMapDetailModalProps) {
        super(props);

        this.state = {
            display: props.display,
            dive: props.dive,
            shared: props.shared
        };
    }

    componentWillReceiveProps(nextProps: IDivesMapDetailModalProps) {
        this.setState({
            display: nextProps.display,
            dive: nextProps.dive,
            shared: nextProps.shared
        });
    }

    hideModal() {
        if (this.props.hideConfirmSubmit !== undefined) {
            this.props.hideConfirmSubmit();
        } else {
            this.setState({
                display: false,
                dive: null
            });
        }
    }

    onClickShowDive(e: Event) {
        if (this.state.shared !== true && this.props.viewDetail !== undefined) {
            this.props.viewDetail(e);
        }
        if (
            this.state.shared === true &&
            this.props.viewSharedDetail !== undefined
        ) {
            this.props.viewSharedDetail(e);
        }
        this.hideModal();
        e.preventDefault();
    }

    onClickStorno(e: Event) {
        this.hideModal();
        e.preventDefault();
    }

    onClickToOverlay(e: Event) {
        this.hideModal();
        e.stopPropagation();
    }

    render() {
        if (this.state.dive === null) {
            return null;
        }

        return (
            <div
                className={
                    'modalOverlay' + (this.state.display ? '' : ' hidden')
                }
                onClick={e => this.onClickToOverlay(e as any)}
            >
                <div className="modalSlide">
                    <div className="modal diveMapDetail">
                        <button
                            className="close"
                            onClick={e => this.onClickStorno(e as any)}
                        />
                        <div className="modal-header">
                            {this.state.shared !== true && <h3>My Dive</h3>}
                            {this.state.shared === true && <h3>Shared Dive</h3>}
                        </div>
                        <div className="modal-content">
                            <p>
                                {this.state.shared === true && (
                                    <span>
                                        User: {this.state.dive.user}
                                        <br />
                                    </span>
                                )}
                                Max. depth:{' '}
                                <DisplayDepth data={this.state.dive.maxDepth} />
                                <br />
                                Duration: {this.state.dive.duration}
                            </p>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn--xsmallpill btn--backroundRed"
                                onClick={e => this.onClickShowDive(e as any)}
                            >
                                Go to dive detail
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DivesMapDetailModal.tsx